import { Link } from "react-router-dom";
import React, { useCallback, useEffect, useRef, useState } from "react";
import logo from "../../Resources/iconwhite.png";
import { LanguageSwitcher } from "../../i18n/LanguageSwitcher";
import { useI18n } from "../../i18n/LanguageContext";

import "./Menubar.scss";

export const MenuBar = () => {
  const [navOpen, setNavOpen] = useState(false);
  const { t } = useI18n();
  const navRef = useRef<HTMLElement>(null);

  const closeNav = useCallback(() => setNavOpen(false), []);

  useEffect(() => {
    if (!navOpen) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        closeNav();
        return;
      }
      if (e.key !== "Tab" || !navRef.current) return;
      const focusables = navRef.current.querySelectorAll<HTMLElement>(
        'a[href], button:not([disabled])'
      );
      if (!focusables.length) return;
      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    };
    document.addEventListener("keydown", onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    navRef.current?.querySelector<HTMLElement>("a, button")?.focus();
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = prev;
    };
  }, [navOpen, closeNav]);

  return (
    <>
      <a className="skip-link" href="#contenido-principal">
        {t("nav.skip")}
      </a>
      <header className="topbar">
        <div className="topbar__start">
          <Link to="/" title={t("nav.home")} onClick={closeNav}>
            <img src={logo} width={50} height={50} alt={t("nav.home")} />
          </Link>
        </div>
        <div className="topbar__tools">
          <LanguageSwitcher />
          <button
            type="button"
            className="topbar__toggle"
            aria-expanded={navOpen}
            aria-controls="nav-principal"
            onClick={() => setNavOpen((o) => !o)}
          >
            <span className="visually-hidden">
              {navOpen ? t("nav.closeMenu") : t("nav.openMenu")}
            </span>
            <span className="topbar__toggle-bars" aria-hidden>
              <span />
              <span />
              <span />
            </span>
          </button>
        </div>
        <div
          className={`topbar__backdrop${navOpen ? " is-visible" : ""}`}
          aria-hidden
          onClick={closeNav}
        />
        <nav
          id="nav-principal"
          ref={navRef}
          className={`topbar__menu${navOpen ? " is-open" : ""}`}
          aria-label={t("nav.main")}
          onClick={(e) => e.stopPropagation()}
        >
          <Link to="/pontepie" title={t("nav.aboutTitle")} onClick={closeNav}>
            <span>{t("nav.about")}</span>
          </Link>
          <Link to="/servicios" title={t("nav.services")} onClick={closeNav}>
            <span>{t("nav.services")}</span>
          </Link>
          <Link to="/cita" title={t("nav.book")} onClick={closeNav}>
            <span className="topbar__highlight">{t("nav.book")}</span>
          </Link>
          <Link to="/contacto" title={t("nav.contact")} onClick={closeNav}>
            <span>{t("nav.contact")}</span>
          </Link>
        </nav>
      </header>
    </>
  );
};
